import { authModuleName, authReducer } from "../../../modules/auth/slice";
import { IAuthState } from "../../../modules/auth/types";
import { gameModuleName, gameReducer } from "../../../modules/game/slice";
import { IGameState } from "../../../modules/game/types";
import { sceneModuleName, sceneReducer } from "../../../modules/scene/slice";
import { ISceneState } from "../../../modules/scene/types";

export interface IRootReducer {
  [authModuleName]: IAuthState;
  [sceneModuleName]: ISceneState;
  [gameModuleName]: IGameState;
}

export const rootReducer = {
  [authModuleName]: authReducer,
  [sceneModuleName]: sceneReducer,
  [gameModuleName]: gameReducer,
};
